import { bootstrapApplication } from '@angular/platform-browser';
import { ErrorHandler, importProvidersFrom } from '@angular/core';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

import { ApmModule, ApmService, ApmErrorHandler } from '@elastic/apm-rum-angular';
import { environment } from './environments/environment';

bootstrapApplication(AppComponent, {
  providers: [
    ...appConfig.providers,
    importProvidersFrom(ApmModule),
    ApmService,
    { provide: ErrorHandler, useClass: ApmErrorHandler }
  ]
})
.then(appRef => {
  const apmService = appRef.injector.get(ApmService);
  const apm = apmService.init({
    serviceName: environment.elasticAPM.elasticServiceName,
    serverUrl: environment.elasticAPM.elasticServerUrl,
    environment: environment.elasticAPM.environment,
    serviceVersion: environment.elasticAPM.serviceVersion,
    distributedTracingOrigins: environment.elasticAPM.distributedTracingOrigins,
    propagateTracestate: environment.elasticAPM.propagateTracestate,
  });
})
.catch(err => console.error(err));
